// LogoUploader.jsx
import { useState } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Image,
  Box,
  Text,
} from "@chakra-ui/react";

const MAX_FILE_SIZE_MB = 2;

export const LogoUploader = ({ indice, setIndice }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileError, setFileError] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
    if (!validTypes.includes(file.type)) {
      setFileError("Solo se permiten imágenes JPG, PNG o WEBP.");
      setIndice({ ...indice, logo: null });
      setPreviewUrl(null);
      return;
    }

    const maxSize = MAX_FILE_SIZE_MB * 1024 * 1024;
    if (file.size > maxSize) {
      setFileError(`El tamaño máximo permitido es de ${MAX_FILE_SIZE_MB}MB.`);
      setIndice({ ...indice, logo: null });
      setPreviewUrl(null);
      return;
    }

    setFileError(null);
    setIndice({ ...indice, logo: file });

    const imageUrl = URL.createObjectURL(file);
    setPreviewUrl(imageUrl);
  };

  return (
    <FormControl>
      <FormLabel fontWeight="semibold">LOGO</FormLabel>
      <Input type="file" accept="image/*" onChange={handleFileChange} />
      {fileError && (
        <Text color="red.500" fontSize="sm" mt={1}>
          {fileError}
        </Text>
      )}

      {previewUrl && (
        <Box mt={3}>
          <Text fontWeight="semibold" fontSize="sm">
            Vista previa:
          </Text>
          <Image
            src={previewUrl}
            alt="Vista previa del logo"
            boxSize="120px"
            objectFit="contain"
            border="1px solid #ddd"
            borderRadius="md"
            mt={1}
          />
        </Box>
      )}
    </FormControl>
  );
};
